<template>
	<img :class="export_class" v-if="width == 0" src="../../assets/img/icon/namaste.png" width="250">
	<img :class="export_class" v-else src="../../assets/img/icon/namaste.png" :width="width">
</template>
<script>
	export default{
		props:{
			width:{
				type: Number,
				default: 0
			},
			custom_class:{
				type: String,
				default: ''
			}
		},
		computed:{
			export_class(){
				if (this.class != '') {
					return this.class
				}
				return ''
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/DefaultImage.vue